module.exports = __webpack_public_path__ + "img/team-member.614c0654.svg";